export interface IUserDataState {
  deploymentId?: string;
  isLogin: boolean;
  commentRepliedCount?: number;
  // YJ製のアプリか
  isAppByYJ: boolean;
  // IEか
  isIE: boolean;
  // Chromeかどうか
  isChrome?: boolean;
  abTestBuckets: { experimentId: string; bucket: string; isTopicsHeadingTest: boolean }[] | null;
}
const initialState: IUserDataState = {
  isLogin: false,
  isAppByYJ: false,
  isIE: false,
  abTestBuckets: null
};
export default (state: IUserDataState = initialState) => {
  return state;
};
